import './EventListItem.scss'

import { CalendarIcon } from '@react/FilterableList/UI/CalendarIcon'
import { EventObjectType, getEventDateObject } from '@react/FilterableList/utils/events'
import { useContext } from 'react'

import { FilterableListContext } from '../../../FilterableListContext'
import { ItemType, TranslationsType } from '../../../FilterableListTypes'
import { ListTypeItem } from '../../../UI/ListTypeItem'

type EventListItemProps = {
  item: ItemType
}

const EventTagAndCalendarIcon = ({ item, translations }: { item: ItemType; translations: TranslationsType }) => {
  return (
    <div className="cmp-filterable-list__card-tag-and-icon">
      <span className="cmp-filterable-list__card-tag-and-icon--icon">
        <CalendarIcon item={item} unscheduledEventsUpcomingLabel={translations.unscheduledEventsUpcomingLabel} />
      </span>
    </div>
  )
}

const EventDateAndLocationComponent = ({ item, eventObject, location }: { item: ItemType; eventObject: EventObjectType; location: string }) => {
  return (
    <div className="cmp-filterable-list__card-event-date-and-location">
      <div className="cmp-filterable-list__card-event-date-and-location-wrapper">
        {!eventObject.end && <div className="cmp-filterable-list__card-event-date-and-location--date">{eventObject.start}</div>}
        {eventObject.end && (
          <>
            <div className="cmp-filterable-list__card-event-date-and-location--date">
              <span>from</span> {eventObject.start} <span>to</span> {eventObject.end}
            </div>
          </>
        )}
        {location && <div className="cmp-filterable-list__card-event-date-and-location--location">{location}</div>}
      </div>
      {item.tagValue && <span className="cmp-filterable-list__card-tag-and-icon--tag-value">{item.tagValue}</span>}
    </div>
  )
}

// Event titles are nested under the EventListSectionHeader, so they must render one level deeper.
const getNestedHeadingElement = (seoHeadingElement: string): string => {
  const level = Math.min(Number(seoHeadingElement.replace('h', '')) + 1, 6)
  return `h${level}`
}

const EventTitleComponent = ({
  eventObject,
  item,
  seoHeadingElement = 'h5',
}: {
  eventObject: EventObjectType
  item: ItemType
  seoHeadingElement?: string
}) => {
  const HeadingTag = getNestedHeadingElement(seoHeadingElement) as keyof JSX.IntrinsicElements

  return (
    <>
      <EventDateAndLocationComponent item={item} eventObject={eventObject} location={item.location} />
      <HeadingTag className="cmp-filterable-list__card-title h5">{item.title}</HeadingTag>
    </>
  )
}

export const EventListItem = ({ item }: EventListItemProps) => {
  const { propsState, translationsState } = useContext(FilterableListContext)
  const eventDateObject = getEventDateObject(item, translationsState)

  return (
    <>
      <ListTypeItem
        customTitle={<EventTitleComponent item={item} eventObject={eventDateObject} seoHeadingElement={propsState.seoHeadingElement} />}
        item={item}
        showDescription={true}
        showMetaTag={false}
        showMetaDate={false}
        showMetaTimeToRead={false}
        showButton={true}
      >
        <EventTagAndCalendarIcon item={item} translations={translationsState} />
      </ListTypeItem>
    </>
  )
}
